export default __webpack_public_path__ + "static/comfortingHumiliated-4f6cb7021a592208ab5d196dd3c747f5.svg";